export default __webpack_public_path__ + "static/media/briefcase.8a2a3cb3.svg";